const customers = {
  breadcrumb: {
    root: "Clientes",
    new: "Nuevo cliente",
    detail: "Cliente",
    favorites: "Destacados",
    offers: "Ofertas",
  },
  list: {
    title: "Directorio de clientes",
    alert:
      "Guarda los datos de tus clientes para contactarlos y reutilizarlos cuando lo necesites.",
    groups: "Grupos",
    favorites: "Destacados",
    offers: "Ofertas",
    member: "miembro",
    members: "miembros",
    contacts: "Contactos",
    select: "Seleccionar",
    cancel: "Cancelar",
    selectAll: "Seleccionar todos",
    emptyTitle: "Aún no tienes clientes",
    emptyDescription: "Crea tu primer cliente para empezar a gestionar tu directorio.",
    emptyCta: "Crear cliente",
    loading: "Cargando clientes...",
    loadError: "No se pudieron cargar los clientes",
    retry: "Reintentar",
    create: "Crear cliente",
  },
  detail: {
    newTitle: "Nuevo cliente",
    editTitle: "Cliente",
    typeLabel: "Tipo de cliente",
    person: "Persona",
    business: "Empresa",
    save: "Guardar",
    favorite: "Destacado",
    delete: "Eliminar",
    saved: "Cliente guardado",
    deleted: "Cliente eliminado",
    saveError: "No se pudo guardar el cliente",
    deleteError: "No se pudo eliminar el cliente",
    notFound: "No encontramos este cliente",
    backToList: "Volver al directorio",
  },
  form: {
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    businessName: "Nombre de la empresa",
    adminName: "Nombre del administrador",
    businessCode: "NIT o código",
    businessEmail: "Correo electrónico",
    city: "Ciudad",
    address: "Dirección",
    businessPhone: "Teléfono de la empresa",
    adminPhone: "Teléfono del administrador",
    nameRequired: "El nombre es obligatorio",
    phoneRequired: "El teléfono es obligatorio",
    emailInvalid: "Ingresa un correo válido",
    adminNameRequired: "El nombre del administrador es obligatorio",
    businessCodeRequired: "El NIT o código es obligatorio",
    addressRequired: "La dirección es obligatoria",
  },
  contact: {
    whatsapp: "WhatsApp",
    email: "Correo",
    call: "Llamar",
    whatsappMessage: "Hola",
  },
  deleteModal: {
    title: "¿Eliminar clientes?",
    description: "Esta acción no se puede deshacer. ¿Quieres continuar?",
    cancel: "No",
    confirm: "Eliminar",
    success: "Clientes eliminados",
    error: "No se pudieron eliminar los clientes",
  },
};

export default customers;
